import type { IntrusionLocation } from '@/views/intrusion/types';

import type { IntrusionSourcePlace } from './types';

type IntrusionPlacedEntity = {
  placeID?: string | null;
  Place?: IntrusionSourcePlace | null;
  description?: string | null;
};

type IntrusionPlacedEntityDevice =
  | {
      gateway?: { place?: IntrusionSourcePlace | null } | null;
    }
  | null
  | undefined;

export const mapIntrusionEntityPlace = (
  entity: IntrusionPlacedEntity,
  device: IntrusionPlacedEntityDevice
): IntrusionLocation => {
  const place = entity?.Place?.id ? entity.Place : device?.gateway?.place;

  return {
    id: place?.id || undefined,
    name: place?.name || 'Unassigned',
    hierarchy: place?.hierarchy ?? undefined
  };
};

export const mapIntrusionEntityDetails = (
  entity: IntrusionPlacedEntity,
  device: IntrusionPlacedEntityDevice
): { description?: string; place: IntrusionLocation } => ({
  description: entity?.description || undefined,
  place: mapIntrusionEntityPlace(entity, device)
});
